import "@plugins/axios";
import store from "@store/store";
import crypto from "crypto";

export const compareVersion = (newVersion, oldVersion) => {
    const oldArr = oldVersion.split(".");
    const newArr = newVersion.split(".");
    const oldLen = oldArr.length;
    const newLen = newArr.length;
    const minLen = Math.min(oldLen, newLen);
    let i = 0;
    for (; i < minLen; i++) {
        const oldVal = parseInt(oldArr[i]);
        const newVal = parseInt(newArr[i]);
        if (newVal > oldVal) {
            return 1;
        } else if (newVal < oldVal) {
            return -1;
        }
    }
    if (newLen > oldLen) {
        for (let j = 0; j < newLen; j++) {
            if (parseInt(newArr[j]) !== 0) {
                return 1;
            }
        }
    } else if (newLen < oldLen) {
        for (let j = 0; j < oldLen; j++) {
            if (parseInt(oldArr[j]) !== 0) {
                return -1;
            }
        }
    }
    return 0;
};

export const checkVersion = () => {
    axios
        .get("version.json", { headers: { "Cache-Control": "no-cache" } })
        .then((res) => {
            // 最新版本
            const latestVersion = res.data.version;

            // 当前版本
            const clientVersion = localStorage.getItem("version");
            if (clientVersion === "null" || !clientVersion) {
                localStorage.setItem("version", latestVersion);
                return;
            }
            const compareRes = compareVersion(latestVersion, clientVersion);
            store.dispatch("setVersionFlag", compareRes);
        });
};

export const getBroker = () => {
    let broker = null;
    // Production Mode
    if (window.location.hostname.includes("pk-")) {
        broker = window.location.hostname
            .replace("pk-", "")
            .replace(".sigmarisk.com.au", "")
            .toLocaleUpperCase();
    } else {
        // Development Mode
        broker = process.env.VUE_APP_SOCKET_API.replace("https://socket-", "")
            .replace(".sigmarisk.com.au", "")
            .toLocaleUpperCase();
    }
    if (broker === "BB") {
        broker = "BLUEBERRY";
    }
    return broker;
};

export function decodeJwt(token) {
    const parts = token.split(".");
    if (parts.length !== 3) throw new Error("Not a JWT");

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
        atob(base64)
            .split("")
            .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
            .join("")
    );
    return JSON.parse(json); // payload object
}

function sign(payload) {
    return crypto
        .createHmac("sha256", "super-secure")
        .update(payload)
        .digest("base64");
}
export const redirectToRH = (url) => {
    const currentURL = window.location.origin;
    const redirectURL = currentURL.includes("localhost")
        ? currentURL.replace("7001", "80")
        : currentURL.replace("pk", "riskhub");
    // 从 localStorage 获取 email（登录时存储的）
    const email = localStorage.getItem("userEmail") || "";

    const params = new URLSearchParams({
        redirection: url,
        email: email,
        sig: sign(email),
    });
    const finalURL = `${redirectURL}/redirection?${params.toString()}`;
    window.open(finalURL, "_blank");
};
